import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  exportExcelReq,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  emptySearchInfo: {
    searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    searchTransId: '',
    searchEntityId: '',
    searchInvCollectUnitId: '',
    searchInvNumber: '',
    searchInvBillUnit: '',
    searchInvAmt: 0,
    searchCertStatus: '',
    searchDocMth: '',
    searchDocIndex: 0,
    searchDocMonthIndex: '',
    searchDocType: ''
  },
  searchInfo: {
    // entityId: '',
    // projId: '',
    // compId: '',
    searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    searchTransId: '',
    searchEntityId: '',
    searchInvCollectUnitId: '',
    searchInvNumber: '',
    searchInvBillUnit: '',
    searchInvAmt: 0,
    searchCertStatus: '',
    searchDocMth: '',
    searchDocIndex: 0,
    searchDocMonthIndex: '',
    searchDocType: ''
  },
  searchedForm: {
    // entityId: '',
    // projId: '',
    // compId: '',
    searchType: 'MONTH',
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    searchTransId: '',
    searchEntityId: '',
    searchInvCollectUnitId: '',
    searchInvNumber: '',
    searchInvBillUnit: '',
    searchInvAmt: 0,
    searchCertStatus: '',
    searchDocMth: '',
    searchDocIndex: 0,
    searchDocMonthIndex: '',
    searchDocType: ''
  },
  invoiceSummary: {},
  invoiceList: [],
  invoiceInfo: {
    invId: '',
    colType: '',
    compId: '',
    projId: '',
    entityId: '',
    transId: '',
    invCollectUnitId: '',
    invCode: '',
    invNumber: '',
    invDt: '',
    invBillUnit: '',
    invContent: '',
    invValueAmt: 0,
    indManualDeductibleValue: '',
    invDeductibleAmt: 0,
    invSubtotalAmt: 0,
    invType: '',
    invRate: 0,
    invPaymentType: '',
    submitDt: '',
    certAmt: 0,
    remarks: '',
    // indDel: '',
    crtBy: '',
    crtOn: '',
    updBy: '',
    updOn: '',
    //
    indUsed: ''
  },
  editIndex: -1,
  justUpdatedIndex: -1,
  editAction: '',
  // editSubmitDt: '',
  // editCertAmt: 0,
  // editRemarks: '',
  invNumberList: [],
  invBillUnitList: [],
  END_STATE: null
}

const getters = {

}

const actions = {
  async insertProjSettleInvoice({
    dispatch,
    commit,
    state
  }, {transId, projId, compId, codeParam}) {
    // debugger
    const insertObj = await postReq(END_POINTS.INSERT_RSP_PROJ_SETTLE_INVOICE, {
      data: {
        // invId: state.invoiceInfo.invId,
        // colType: state.invoiceInfo.colType,
        // entityId: state.invoiceInfo.entityId,
        // transId: state.invoiceInfo.transId,
        invCollectUnitId: state.invoiceInfo.invCollectUnitId,
        invCode: state.invoiceInfo.invCode,
        invNumber: state.invoiceInfo.invNumber,
        invDt: new Date(state.invoiceInfo.invDt).getTime(),
        invBillUnit: state.invoiceInfo.invBillUnit,
        invContent: state.invoiceInfo.invContent,
        invValueAmt: state.invoiceInfo.invValueAmt || 0,
        indManualDeductibleValue: state.invoiceInfo.indManualDeductibleValue,
        invDeductibleAmt: state.invoiceInfo.invDeductibleAmt || 0,
        // invSubtotalAmt: state.invoiceInfo.invSubtotalAmt,
        invType: state.invoiceInfo.invType,
        invRate: state.invoiceInfo.invRate,
        invPaymentType: state.invoiceInfo.invPaymentType,
        submitDt: new Date(state.invoiceInfo.submitDt).getTime(),
        certAmt: state.invoiceInfo.certAmt || 0,
        remarks: state.invoiceInfo.remarks,
        // crtBy: state.invoiceInfo.crtBy,
        // crtOn: state.invoiceInfo.crtOn,
        // updBy: state.invoiceInfo.updBy,
        // updOn: state.invoiceInfo.updOn,
        //
        transId: transId,
        // entityId: entityId,
        projId: projId,
        compId: compId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return insertObj
  },
  async updateProjSettleInvoice({
    dispatch,
    commit,
    state
  }, {invId, projId, compId, codeParam}) {
    // console.log(transId)
    // debugger
    let invoiceInfo = {
      // invId: state.invoiceInfo.invId,
      // colType: state.invoiceInfo.colType,
      // entityId: state.invoiceInfo.entityId,
      // transId: state.invoiceInfo.transId,
      invCollectUnitId: state.invoiceInfo.invCollectUnitId,
      invCode: state.invoiceInfo.invCode,
      invNumber: state.invoiceInfo.invNumber,
      invDt: new Date(state.invoiceInfo.invDt).getTime(),
      invBillUnit: state.invoiceInfo.invBillUnit,
      invContent: state.invoiceInfo.invContent,
      invValueAmt: state.invoiceInfo.invValueAmt || 0,
      indManualDeductibleValue: state.invoiceInfo.indManualDeductibleValue,
      invDeductibleAmt: state.invoiceInfo.invDeductibleAmt || 0,
      // invSubtotalAmt: state.invoiceInfo.invSubtotalAmt,
      invType: state.invoiceInfo.invType,
      invRate: state.invoiceInfo.invRate,
      invPaymentType: state.invoiceInfo.invPaymentType,
      // submitDt: new Date(state.invoiceInfo.submitDt).getTime(),
      // certAmt: state.invoiceInfo.certAmt,
      remarks: state.invoiceInfo.remarks,
      // crtBy: state.invoiceInfo.crtBy,
      // crtOn: state.invoiceInfo.crtOn,
      // updBy: state.invoiceInfo.updBy,
      // updOn: state.invoiceInfo.updOn,
      //
      key: {
        invId: invId,
        // transId: transId,
        // entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_SETTLE_INVOICE, {
      data: invoiceInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async removeProjSettleInvoice({
    commit,
    state
  }, {invId, projId, compId, codeParam}) {
    const deleteObject = await deleteSendReq(END_POINTS.REMOVE_RSP_PROJ_SETTLE_INVOICE + `?invId=${invId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return deleteObject
  },
  async updateProjSettleInvoiceCertInfo({
    dispatch,
    commit,
    state
  }, {submitDt, certAmt, remarks, invId, projId, compId, codeParam}) {
    // console.log(transId)
    // debugger
    let invoiceInfo = {
      submitDt,
      certAmt: certAmt || 0,
      remarks,
      //
      key: {
        invId: invId,
        // transId: transId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_SETTLE_INVOICE_CERT_INFO, {
      data: invoiceInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async findProjSettleInvoiceList({
    commit,
    state,
    rootState
  }, { invId, projId, compId, codeParam }) {
    let searchedForm = state.searchedForm || state.emptySearchInfo
    // debugger
    let data = {
      invId: invId,
      // entityId: entityId,
      projId: projId,
      compId: compId,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime(),
      searchTransId: searchedForm.searchTransId,
      searchEntityId: searchedForm.searchEntityId,
      searchInvCollectUnitId: searchedForm.searchInvCollectUnitId,
      searchInvNumber: searchedForm.searchInvNumber,
      searchInvBillUnit: searchedForm.searchInvBillUnit,
      searchInvAmt: searchedForm.searchInvAmt,
      searchCertStatus: searchedForm.searchCertStatus,
      searchDocMth: searchedForm.searchDocMth,
      searchDocIndex: searchedForm.searchDocIndex || 0,
      searchDocMonthIndex: searchedForm.searchDocMonthIndex || '',
      searchDocType: searchedForm.searchDocType || ''
    }

    const response = await postReq(END_POINTS.FIND_RSP_PROJ_SETTLE_INVOICE_LIST, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return response
    // state.searchedForm = data
    // commit('updateSearchedForm', data)
    // commit('updateProjSettleInvoiceList', response)
  },
  async downloadProjSettleInvoiceList({
    commit,
    state,
    rootState
  }, { entityId, projId, compId, codeParam }) {
    let searchedForm = state.searchedForm || state.emptySearchInfo
    let data = {
      entityId: entityId,
      projId: projId,
      compId: compId,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime(),
      searchTransId: searchedForm.searchTransId,
      searchEntityId: searchedForm.searchEntityId,
      searchInvCollectUnitId: searchedForm.searchInvCollectUnitId,
      searchInvNumber: searchedForm.searchInvNumber,
      searchInvBillUnit: searchedForm.searchInvBillUnit,
      searchInvAmt: searchedForm.searchInvAmt,
      searchCertStatus: searchedForm.searchCertStatus,
      searchDocMth: searchedForm.searchDocMth,
      searchDocIndex: searchedForm.searchDocIndex || 0,
      searchDocMonthIndex: searchedForm.searchDocMonthIndex || '',
      searchDocType: searchedForm.searchDocType || ''
    }

    const response = await exportExcelReq(END_POINTS.DOWNLOAD_RSP_PROJ_SETTLE_INVOICE_LIST, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    // console.log('exportExcelReq.resp:', response)
    return response
  },
  async findRspProjSettleInvoiceSum({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    let searchedForm = state.searchedForm || state.emptySearchInfo
    // debugger
    let data = {
      // invId: invId,
      // entityId: entityId,
      projId: projId,
      compId: compId,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: 'TOTAL',
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime(),
      searchTransId: searchedForm.searchTransId,
      searchEntityId: searchedForm.searchEntityId,
      searchInvCollectUnitId: searchedForm.searchInvCollectUnitId,
      searchInvNumber: searchedForm.searchInvNumber,
      searchInvBillUnit: searchedForm.searchInvBillUnit,
      searchInvAmt: searchedForm.searchInvAmt,
      searchCertStatus: searchedForm.searchCertStatus,
      searchDocMth: searchedForm.searchDocMth,
      searchDocIndex: searchedForm.searchDocIndex || 0,
      searchDocMonthIndex: searchedForm.searchDocMonthIndex || '',
      searchDocType: searchedForm.searchDocType || ''
    }

    const response = await postReq(END_POINTS.FIND_RSP_PROJ_SETTLE_INVOICE_SUM, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    // return response
    // state.searchedForm = data
    // commit('updateSearchedForm', data)
    commit('updateInvoiceSummary', response)
  },
  async findInvNumberList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_INV_NUMBER_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateInvNumberList', response)
  },
  async findInvBillUnitList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_INV_BILL_UNIT_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateInvBillUnitList', response)
  },
  END_ACTIONS() {}
}

const mutations = {
  async updateSearchedForm(state) {
    state.searchedForm = {...state.searchInfo}
  },
  async updateSearchInfo(state, searchInfo) {
    state.searchInfo = {...searchInfo}
  },
  async resetSearchInfo(state) {
    state.searchInfo = {...state.emptySearchInfo}
  },
  updateSearchType(state, value) {
    state.searchInfo.searchType = value
  },
  updateSearchMonth(state, value) {
    state.searchInfo.searchMonth = value
  },
  updateSearchMonthType(state, value) {
    state.searchInfo.searchMonthType = value
  },
  // updateSearchDtScope(state, value) {
  //   state.searchInfo.searchDtScope = value
  // },
  updateSearchStartDt(state, value) {
    state.searchInfo.searchStartDt = value
  },
  updateSearchEndDt(state, value) {
    state.searchInfo.searchEndDt = value
  },
  updateSearchTransId(state, value) {
    state.searchInfo.searchTransId = value
  },
  updateSearchEntityId(state, value) {
    state.searchInfo.searchEntityId = value
  },
  updateSearchInvCollectUnitId(state, value) {
    state.searchInfo.searchInvCollectUnitId = value
  },
  updateSearchInvNumber(state, value) {
    state.searchInfo.searchInvNumber = value
  },
  updateSearchInvBillUnit(state, value) {
    state.searchInfo.searchInvBillUnit = value
  },
  updateSearchInvAmt(state, value) {
    state.searchInfo.searchInvAmt = value
  },
  updateSearchCertStatus(state, value) {
    state.searchInfo.searchCertStatus = value
  },
  updateSearchDocMth(state, value) {
    state.searchInfo.searchDocMth = value
  },
  updateSearchDocIndex(state, value) {
    state.searchInfo.searchDocIndex = value
  },
  updateSearchDocMonthIndex(state, value) {
    state.searchInfo.searchDocMonthIndex = value
  },
  updateSearchDocType(state, value) {
    state.searchInfo.searchDocType = value
  },
  //
  updateInvId(state, value) {
    state.invoiceInfo.invId = value
  },
  updateColType(state, value) {
    state.invoiceInfo.colType = value
  },
  updateCompId(state, value) {
    state.invoiceInfo.compId = value
  },
  updateProjId(state, value) {
    state.invoiceInfo.projId = value
  },
  updateEntityId(state, value) {
    state.invoiceInfo.entityId = value
  },
  updateTransId(state, value) {
    state.invoiceInfo.transId = value
  },
  updateInvCollectUnitId(state, value) {
    state.invoiceInfo.invCollectUnitId = value
  },
  updateInvCode(state, value) {
    state.invoiceInfo.invCode = value
  },
  updateInvNumber(state, value) {
    state.invoiceInfo.invNumber = value
  },
  updateInvDt(state, value) {
    state.invoiceInfo.invDt = value
  },
  updateInvBillUnit(state, value) {
    state.invoiceInfo.invBillUnit = value
  },
  updateInvContent(state, value) {
    state.invoiceInfo.invContent = value
  },
  updateInvValueAmt(state, value) {
    state.invoiceInfo.invValueAmt = value
  },
  updateIndManualDeductibleValue(state, value) {
    state.invoiceInfo.indManualDeductibleValue = value
  },
  updateInvDeductibleAmt(state, value) {
    state.invoiceInfo.invDeductibleAmt = value
  },
  // updateInvSubtotalAmt(state, value) {
  //   state.invoiceInfo.invSubtotalAmt = value
  // },
  updateInvType(state, value) {
    state.invoiceInfo.invType = value
  },
  updateInvRate(state, value) {
    state.invoiceInfo.invRate = value
  },
  updateInvPaymentType(state, value) {
    state.invoiceInfo.invPaymentType = value
  },
  updateSubmitDt(state, value) {
    state.invoiceInfo.submitDt = value
  },
  updateCertAmt(state, value) {
    state.invoiceInfo.certAmt = value
  },
  updateRemarks(state, value) {
    state.invoiceInfo.remarks = value
  },
  // updateIndDel(state, value) {
  //   state.invoiceInfo.indDel = value
  // },
  // updateCrtBy(state, value) {
  //   state.invoiceInfo.crtBy = value
  // },
  // updateCrtOn(state, value) {
  //   state.invoiceInfo.crtOn = value
  // },
  // updateUpdBy(state, value) {
  //   state.invoiceInfo.updBy = value
  // },
  // updateUpdOn(state, value) {
  //   state.invoiceInfo.updOn = value
  // },
  //
  updateProjSettleInvoiceList(state, list) {
    // if (response.success === true && response.data.length) {
    //   state.invoiceList = response.data
    //   // state.invoiceList = []
    // } else {
    //   state.invoiceList = []
    // }
    if (list.length) {
      state.invoiceList = list
      // state.transList = []
    } else {
      state.invoiceList = []
    }
  },
  updateProjSettleInvoiceListItem(state, {row, index}) {
    // if (state.invoiceList && state.invoiceList.length && index >= 0 && index < state.invoiceList.length) {
    //   Object.keys(row).forEach(key => {
    //     state.invoiceList[index][key] = row[key]
    //   })
    // }
    if (state.invoiceList && state.invoiceList.length && index >= 0 && index < state.invoiceList.length) {
      if (row) {
        Object.keys(row).forEach(key => {
          state.invoiceList[index][key] = row[key]
        })
      } else {
        state.invoiceList.splice(index, 1)
      }
    }
  },
  updateProjSettleInvoiceListEmpty(state) {
    state.editIndex = -1
    state.justUpdatedIndex = -1
    state.invoiceList = []
    state.invoiceSummary = {}
  },
  updateInvoiceSummary(state, response) {
    if (response.success) {
      state.invoiceSummary = response.data
    } else {
      state.invoiceSummary = {}
    }
  },
  updateInvNumberList(state, response) {
    if (response.success === true && response.data.length) {
      state.invNumberList = Utils.toListWapper(response.data, {valueField: 'value', descrField: 'value'})
    } else {
      state.invNumberList = []
    }
  },
  updateInvBillUnitList(state, response) {
    if (response.success === true && response.data.length) {
      state.invBillUnitList = Utils.toListWapper(response.data, {valueField: 'value', descrField: 'value'})
    } else {
      state.invBillUnitList = []
    }
  },
  updateProjSettleInvoiceEmpty(state) {
    state.invoiceInfo.invId = ''
    state.invoiceInfo.colType = ''
    state.invoiceInfo.compId = ''
    state.invoiceInfo.projId = ''
    state.invoiceInfo.entityId = ''
    state.invoiceInfo.transId = ''
    state.invoiceInfo.invCollectUnitId = ''
    state.invoiceInfo.invCode = ''
    state.invoiceInfo.invNumber = ''
    state.invoiceInfo.invDt = ''
    state.invoiceInfo.invBillUnit = ''
    state.invoiceInfo.invContent = ''
    state.invoiceInfo.invValueAmt = Utils.covertZeroToNull(0)
    state.invoiceInfo.indManualDeductibleValue = ''
    state.invoiceInfo.invDeductibleAmt = Utils.covertZeroToNull(0)
    // state.invoiceInfo.invSubtotalAmt = Utils.covertZeroToNull(0)
    state.invoiceInfo.invType = ''
    state.invoiceInfo.invRate = 0
    state.invoiceInfo.invPaymentType = ''
    state.invoiceInfo.submitDt = ''
    state.invoiceInfo.certAmt = Utils.covertZeroToNull(0)
    state.invoiceInfo.remarks = ''
    // state.invoiceInfo.indDel = ''
    state.invoiceInfo.crtBy = ''
    state.invoiceInfo.crtOn = ''
    state.invoiceInfo.updBy = ''
    state.invoiceInfo.updOn = ''
  },
  updateProjSettleInvoiceInfo(state, invoiceInfo) {
    // debugger
    state.invoiceInfo.invId = invoiceInfo.invId
    state.invoiceInfo.colType = invoiceInfo.colType
    state.invoiceInfo.compId = invoiceInfo.compId
    state.invoiceInfo.projId = invoiceInfo.projId
    state.invoiceInfo.entityId = invoiceInfo.entityId
    state.invoiceInfo.transId = invoiceInfo.transId
    state.invoiceInfo.invCollectUnitId = invoiceInfo.invCollectUnitId
    state.invoiceInfo.invCode = invoiceInfo.invCode
    state.invoiceInfo.invNumber = invoiceInfo.invNumber
    state.invoiceInfo.invDt = Utils.parseDate(invoiceInfo.invDt)
    state.invoiceInfo.invBillUnit = invoiceInfo.invBillUnit
    state.invoiceInfo.invContent = invoiceInfo.invContent
    state.invoiceInfo.invValueAmt = Utils.covertZeroToNull(invoiceInfo.invValueAmt)
    state.invoiceInfo.indManualDeductibleValue = invoiceInfo.indManualDeductibleValue
    state.invoiceInfo.invDeductibleAmt = Utils.covertZeroToNull(invoiceInfo.invDeductibleAmt)
    // state.invoiceInfo.invSubtotalAmt = Utils.covertZeroToNull(invoiceInfo.invSubtotalAmt)
    state.invoiceInfo.invSubtotalAmt = Utils.covertZeroToNull(0)
    state.invoiceInfo.invType = invoiceInfo.invType
    state.invoiceInfo.invRate = invoiceInfo.invRate
    state.invoiceInfo.invPaymentType = invoiceInfo.invPaymentType
    state.invoiceInfo.submitDt = Utils.parseDate(invoiceInfo.submitDt)
    state.invoiceInfo.certAmt = Utils.covertZeroToNull(invoiceInfo.certAmt)
    state.invoiceInfo.remarks = invoiceInfo.remarks
    state.invoiceInfo.indDel = invoiceInfo.indDel
    state.invoiceInfo.crtBy = invoiceInfo.crtBy
    state.invoiceInfo.crtOn = invoiceInfo.crtOn
    state.invoiceInfo.updBy = invoiceInfo.updBy
    state.invoiceInfo.updOn = invoiceInfo.updOn
  },
  updateEditIndex(state, value) {
    state.editIndex = value
  },
  updateJustUpdatedIndex(state, value) {
    state.justUpdatedIndex = value
  },
  updateEditAction(state, value) {
    state.editAction = value
  },
  // newEmptyRowObj() {
  //   return {
  //     ctrAcctId: '',
  //     type: '',
  //     indUsed: '',
  //     status: ''
  //   }
  // },
  appendBottomRow() {
    this.commit('projSettleInvoiceManage/updateProjSettleInvoiceEmpty')
    let obj = {...state.invoiceInfo}
    // debugger
    obj.isBottomRow = true
    state.invoiceList.push(obj)
  },
  handleCopy(state, {row, index}) {
    const copyInvNumber = (invNumber) => {
      let num = parseInt(invNumber)
      if (!isNaN(num)) {
        num++
        for (let i = 0; i < ('' + invNumber).length - ('' + num).length; i++) {
          num = '0' + num
        }
        return '' + num
      } else {
        return ''
      }
    }
    // debugger
    // this.commit('projSettleInvoiceManage/updateProjSettleInvoiceEmpty')
    this.commit('projSettleInvoiceManage/updateProjSettleInvoiceInfo', row)
    state.invoiceInfo.invId = ''
    state.invoiceInfo.invNumber = copyInvNumber(state.invoiceInfo.invNumber)
    this.commit('projSettleInvoiceManage/updateEditIndex', index)
    this.commit('projSettleInvoiceManage/updateJustUpdatedIndex', -1)
    this.commit('projSettleInvoiceManage/updateEditAction', 'insert')
  },
  handleAdd(state, {row, index}) {
    // debugger
    this.commit('projSettleInvoiceManage/updateProjSettleInvoiceEmpty')
    this.commit('projSettleInvoiceManage/updateEditIndex', index)
    this.commit('projSettleInvoiceManage/updateJustUpdatedIndex', -1)
    this.commit('projSettleInvoiceManage/updateEditAction', 'insert')
    //
    // this.commit('projSettleInvoiceManage/updateCtrAcctId', ctrAcctId)
    // this.commit('projSettleInvoiceManage/updateCostColId', costColId)
    state.invoiceInfo.indManualDeductibleValue = 'N'
  },
  handleEdit(state, {row, index}) {
    // debugger
    this.commit('projSettleInvoiceManage/updateProjSettleInvoiceInfo', row)
    this.commit('projSettleInvoiceManage/updateEditIndex', index)
    this.commit('projSettleInvoiceManage/updateJustUpdatedIndex', -1)
    this.commit('projSettleInvoiceManage/updateEditAction', 'update')
  },
  // handleEditDocIndex(state, {row, index}) {
  //   // debugger
  //   // state.editDocMth = Utils.parseDate(row.docMth)
  //   // state.editDocIndex = row.docIndex
  //   // state.editAllowDuplicate = false
  //   // 不能将当前行设置到invoiceInfo上，添加行记录时，如果去修改索引，就会导致问题
  //   // this.commit('projSettleInvoiceManage/updateProjSettleInvoiceInfo', row)
  //   // this.commit('projSettleInvoiceManage/updateEditIndex', index)
  //   // this.commit('projSettleInvoiceManage/updateEditAction', 'update')
  // },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/projSettleInvoiceManage.js